import GridOn from '@mui/icons-material/GridOn';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function GridOnIcon(props: FixMe) {
  return <GridOn {...props} />;
}

export default GridOnIcon;
